import MatchedMap from 'utilities/src/matchedMap';

import { ButtonBGEnum } from '../../../../types/_bg';

import buttonSiteBlackLightTheme from './_light';

export default new MatchedMap([
  [ButtonBGEnum.Light, buttonSiteBlackLightTheme],
  [ButtonBGEnum.Dark, buttonSiteBlackLightTheme],
]);
